var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { lottieAnimations } from '@backrs_ui/common-ui/src/assets/lottieAnimations';
import { BackrsTextField } from '@backrs_ui/common-ui/src/atoms/BackrsTextField';
import { Box, Button, Divider } from '@mui/material';
import Lottie from 'lottie-react';
import { useForm, FormProvider, Controller } from 'react-hook-form';
export var BackrsForm = function (_a) {
    var fields = _a.fields, onSubmit = _a.onSubmit, defaultValues = _a.defaultValues, buttonLabel = _a.buttonLabel, children = _a.children, methods = _a.methods, isLoading = _a.isLoading;
    var defaultMethods = useForm({ defaultValues: defaultValues });
    var methodsToUse = methods || defaultMethods;
    var formState = methodsToUse.formState;
    var handleSubmit = methodsToUse.handleSubmit(function (data) {
        onSubmit(data);
    });
    var groupedFields = {};
    fields.forEach(function (field) {
        var groupKey = field.group || "__unique_".concat(field.name);
        if (!groupedFields[groupKey]) {
            groupedFields[groupKey] = [];
        }
        groupedFields[groupKey].push(field);
    });
    return (_jsx(FormProvider, __assign({}, methodsToUse, { children: _jsxs(Box, { component: "form", onSubmit: handleSubmit, noValidate: true, mt: 1, width: "100%", children: [Object.entries(groupedFields).map(function (_a) {
                    var groupKey = _a[0], group = _a[1];
                    var isSingleFieldGroup = group.length === 1 && group[0].group === undefined;
                    return (_jsx(Box, { display: isSingleFieldGroup ? 'block' : 'flex', sx: isSingleFieldGroup ? {} : groupContainerStyle, children: group.map(function (field) { return (_jsxs(Fragment, { children: [field.divider && _jsx(Divider, { sx: { my: 2 } }), _jsx(Controller, { name: field.name, control: methodsToUse.control, rules: field.rules, render: function (_a) {
                                        var controllerField = _a.field, error = _a.fieldState.error;
                                        return (_jsx(BackrsTextField, { id: field.name, disabled: field.disabled, name: field.name, label: field.label, type: field.type, placeholder: field.placeholder, icon: field.icon, autoComplete: field.autoComplete, autoFocus: field.autoFocus, value: controllerField.value, onChange: controllerField.onChange, inputProps: field.inputProps, sx: __assign(__assign({}, defaultTextFieldStyle), field.sx), error: error === null || error === void 0 ? void 0 : error.message }));
                                    } })] }, field.id)); }) }, groupKey));
                }), children, buttonLabel && (_jsx(Box, { sx: buttonContainerStyle, children: _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: buttonStyle, disabled: !formState.isValid || isLoading, endIcon: isLoading ? (_jsx(Box, { sx: loadingSpinnerStyle, children: _jsx(Lottie, { animationData: lottieAnimations.dotsDotting, loop: true }) })) : undefined, children: buttonLabel }) }))] }) })));
};
var loadingSpinnerStyle = {
    width: 20,
    height: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
var buttonStyle = {
    mx: 2,
    borderRadius: 6,
    textTransform: 'none',
    fontSize: '1.125rem',
    fontWeight: 700,
    lineHeight: '2rem',
    backgroundColor: appColors.color.navy2,
    boxShadow: 'none',
};
var buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    mt: { xs: 3, sm: 8 },
};
var defaultTextFieldStyle = {
    mb: 1,
    backgroundColor: appColors.color.blue10,
    width: '100%',
};
var groupContainerStyle = {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 2,
};
